import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgot, setForgot] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/conta";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vinda!");
      navigate(redirect);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao entrar");
    } finally { setLoading(false); }
  };

  const requestReset = async () => {
    if (!email) { toast.error("Informe seu e-mail"); return; }
    await api.post("/auth/password-reset/request", { email });
    toast.success("Se o e-mail existir, enviaremos instruções em breve.");
    setForgot(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <h1 className="font-display text-4xl text-[#49392F] text-center">Minha conta</h1>
      <p className="mt-3 text-center text-[13px] text-[#49392F]/70">Acesse para acompanhar seus pedidos.</p>

      <form onSubmit={submit} className="mt-10 space-y-4">
        <input type="email" required placeholder="E-mail" className="duo-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        <input type="password" required placeholder="Senha" className="duo-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        <button type="submit" disabled={loading} className="duo-btn duo-btn-primary w-full" data-testid="login-submit">
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>

      <div className="mt-6 flex justify-between text-[12px] text-[#49392F]/80">
        <button onClick={() => setForgot((v) => !v)} className="link-elegant" data-testid="forgot-toggle">Esqueci minha senha</button>
        <Link to="/cadastro" className="link-elegant" data-testid="link-register">Criar conta</Link>
      </div>

      {forgot && (
        <div className="mt-6 bg-white border border-[#C2A064]/30 p-5">
          <p className="text-[12px] text-[#49392F]/70">Enviaremos um link para redefinir sua senha para o e-mail cadastrado.</p>
          <button onClick={requestReset} className="duo-btn duo-btn-secondary w-full mt-4" data-testid="forgot-submit">Enviar instruções</button>
        </div>
      )}
    </div>
  );
}
